module.exports = __webpack_public_path__ + "img/assistant.26d4a346.png";